import axios from "axios";
import { BASE_URL } from "../Constants/Api";

const api = axios.create({
  baseURL: BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getCandidateDocuments = async (candidateId) => {
  try {
    const response = await api.get("/marketing/candidate-documents", {
      params: { candidateId },
    });
    return response.data || [];
  } catch (error) {
    console.error("Failed to fetch candidate documents:", error);
    throw new Error(
      error?.response?.data?.message || "Failed to load candidate documents"
    );
  }
};

export const uploadCandidateDocument = async (
  candidateId,
  documentType,
  issueDate,
  expiryDate,
  file
) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("candidateId", candidateId);
    formData.append("documentType", documentType);

    if (issueDate) {
      formData.append("issueDate", issueDate);
    }
    if (expiryDate) {
      formData.append("expiryDate", expiryDate);
    }

    const response = await api.post(
      "/marketing/candidate-documents/upload",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Failed to upload candidate document:", error);
    throw new Error(
      error?.response?.data?.message ||
        "Failed to upload candidate document. Accepted formats: PDF, DOCX, PNG, JPG, JPEG, BMP, GIF."
    );
  }
};

export const deleteCandidateDocument = async (candidateId, docType) => {
  try {
    const response = await api.delete("/marketing/candidate-documents/delete", {
      params: { candidateId, docType },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to delete candidate document:", error);
    throw new Error(
      error?.response?.data?.message || "Failed to delete candidate document"
    );
  }
};

export const downloadCandidateDocument = async (fileName) => {
  try {
    const response = await api.post("/marketing/candidate-documents/download", {
      fileName,
    });
    return response.data;
  } catch (error) {
    console.error("Failed to download candidate document:", error);
    throw new Error(
      error?.response?.data?.message ||
        "Failed to download candidate document"
    );
  }
};




